import TransferOrderController from './../controllers/transferorder.controller';
import routeConfig from './../transportauftrag.routes';

const TransferOrderComponent = {
	templateUrl: 'components/transportauftrag/views/transferorder.html',
	controller: TransferOrderController,
	$routeConfig: routeConfig
};

export default TransferOrderComponent;
